import { PATHS } from 'routes/constants';
import { TReferralsTab } from './types';

/** The second level navigation of the Referrals section, the url is the source of truth. */
export const REFERRALS_TABS: TReferralsTab[] = [
	{ value: PATHS.REFERRALS_PAGE, label: 'Referrals' },
	{ value: PATHS.REFERRALS_PARTNERS_PAGE, label: 'Partners' },
	{ value: PATHS.REFERRALS_REPORTS_PAGE, label: 'Reports' },
];
